<div
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="handleTriggerClick($event)">
    <ng-content select="[trigger]"></ng-content>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'opacity-0'"
    [cdkConnectedOverlayPositions]="positions"
    (backdropClick)="handleBackdropClick($event)">
    <div 
        class="w-max rounded-xl border border-slate-200 bg-white shadow-lg overflow-hidden animate-dropdown text-left"
        (click)="handleContentClick()">
        <ng-content select="[content]"></ng-content>
    </div>
</ng-template>